import { useState } from "react";
import { Modal, Card, Input, Button } from "antd";
import {
  CloseOutlined,
} from "@ant-design/icons";

import { TEMPLATE } from "../../../../constants";

import styles from "../common.module.css";
import "../index.css"

const { MODALS } = TEMPLATE.MODAL;
const { TextArea } = Input;

const ModalStandard = (props) => {
  const {
    setmodal,
    isModalOpen,
    setIsModalOpen,
    onClick = () => {},
    extra,
    data = [],
    areatext,
  } = props;


  const [textField, setTextField] = useState("");

  const handleOkButton = () => {
    onClick(textField);
    setIsModalOpen();
  };

  const content =
    (
      extra &&
      Object.keys(extra).length &&
      MODALS[setmodal]?.content(extra)) ||
    MODALS[setmodal]?.content;


  const bulkPublishContent = (
    <p className={styles.textCard}>
      You are about to publish {data.length} billings to customers. 
    </p>
  );
  

  const mainContent = content?.map((line, index) => (
    <p key={index} className={styles.textCard}>
      {line}
    </p>
  ));

  const renderedContent =
    setmodal === "confirmation_bulk_publish_billing_list" ? bulkPublishContent :
    mainContent;

  return (
    <Modal
      open={isModalOpen}
      footer={null}
      onCancel={setIsModalOpen}
      width={400}
    >
      <div
        className={styles["content-container"]}
        style={{ textAlign: "left" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Card
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            <img
              src={MODALS[setmodal]?.img}
              alt="the logo"
              style={{ padding: "7px", width: "50px" }}
            />
          </Card>
          <CloseOutlined
            onClick={setIsModalOpen}
            style={{ marginTop: "-14px" }}
          />
        </div>

        <h3 className={styles["title"]}>{MODALS[setmodal]?.title}</h3>
        <div>{renderedContent}</div>

        {areatext && (
          <TextArea
            placeholder="Add your cancelled remarks"
            onChange={(e) => setTextField(e.target.value)}
            rows={3}
            style={{ resize: "none", margin: "5px 0px" }}
          />
        )}

        <div className={styles["buttons"]}>
          <Button
            onClick={setIsModalOpen}
            className={styles["button"]}
            style={{ borderRadius: "5px", height: "40px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleOkButton}
            className={`${styles["button"]} ${styles["active"]}`}
            style={{ borderRadius: "5px", height: "40px" }}
          >
            Proceed
          </Button>
        </div>
        {/* </div> */}
      </div>
    </Modal>
  );
};

export default ModalStandard;
